export enum UserTypes {
    DSF = 'DSF',
    Consultant = 'Consultant',
    Admin = 'Admin',
    Employee = 'Employee',
    Client = "Client",
    Site = 'Site',
    Unknown = 'Unknown'
}